import axios from 'axios';

axios.defaults.headers = {
    'Authorization': 'Bearer ' + localStorage.getItem('token'),
    'Accept': 'application/json',
};

const state = {
    npStatusMappings: [],
    npStatusMapping: null,
    npCodes: {},
    crmStatuses: [],
    ignoredStatuses: [],
    npCounterparties: [],
    npCounterparty: null,
};

const getters = {
    npStatusMappings: state => state.npStatusMappings,
    npStatusMapping: state => state.npStatusMapping,
    npCodes: state => state.npCodes,
    crmStatuses: state => state.crmStatuses,
    ignoredStatuses: state => state.ignoredStatuses,
    npCounterparties: state => state.npCounterparties,
    npCounterparty: state => state.npCounterparty,
};

const actions = {
    // NP Status Mappings
    getNpStatusMappings: async ({ commit }) => {
        try {
            const result = await axios.get('/np/status-mappings');
            commit('changeNpStatusMappings', result.data.models);
            return {
                status: true,
                data: result.data.models
            };
        } catch (e) {
            console.log(e);
            return {
                status: false,
                data: e.response?.data
            };
        }
    },

    getNpCodes: async ({ commit }) => {
        try {
            const result = await axios.get('/np/status-mappings/np-codes');
            commit('changeNpCodes', result.data.models);
            return {
                status: true,
                data: result.data.models
            };
        } catch (e) {
            console.log(e);
            return {
                status: false,
                data: e.response?.data
            };
        }
    },

    getCrmStatuses: async ({ commit }) => {
        try {
            const result = await axios.get('/np/status-mappings/crm-statuses');
            commit('changeCrmStatuses', result.data.models);
            return {
                status: true,
                data: result.data.models
            };
        } catch (e) {
            console.log(e);
            return {
                status: false,
                data: e.response?.data
            };
        }
    },

    createNpStatusMapping: async (ctx, payload) => {
        try {
            const result = await axios.post('/np/status-mappings', payload);
            return {
                status: true,
                data: result.data
            };
        } catch (e) {
            return {
                status: false,
                data: e.response?.data
            };
        }
    },

    updateNpStatusMapping: async (ctx, { id, data }) => {
        try {
            const result = await axios.put(`/np/status-mappings/${id}`, data);
            return {
                status: true,
                data: result.data
            };
        } catch (e) {
            return {
                status: false,
                data: e.response?.data
            };
        }
    },

    deleteNpStatusMapping: async (ctx, id) => {
        try {
            const result = await axios.delete(`/np/status-mappings/${id}`);
            return {
                status: true,
                data: result.data
            };
        } catch (e) {
            return {
                status: false,
                data: e.response?.data
            };
        }
    },

    // Ignored Statuses
    getIgnoredStatuses: async ({ commit }) => {
        try {
            const result = await axios.get('/np/status-mappings/ignored');
            commit('changeIgnoredStatuses', result.data.models);
            return {
                status: true,
                data: result.data.models
            };
        } catch (e) {
            console.log(e);
            return {
                status: false,
                data: e.response?.data
            };
        }
    },

    addIgnoredStatus: async (ctx, payload) => {
        try {
            const result = await axios.post('/np/status-mappings/ignored', payload);
            return {
                status: true,
                data: result.data
            };
        } catch (e) {
            return {
                status: false,
                data: e.response?.data
            };
        }
    },

    removeIgnoredStatus: async (ctx, id) => {
        try {
            const result = await axios.delete(`/np/status-mappings/ignored/${id}`);
            return {
                status: true,
                data: result.data
            };
        } catch (e) {
            return {
                status: false,
                data: e.response?.data
            };
        }
    },

    // NP Counterparties
    getNpCounterparties: async ({ commit }) => {
        try {
            const result = await axios.get('/np/counterparties');
            commit('changeNpCounterparties', result.data.models);
            return {
                status: true,
                data: result.data.models
            };
        } catch (e) {
            console.log(e);
            return {
                status: false,
                data: e.response?.data
            };
        }
    },

    getNpCounterparty: async ({ commit }, id) => {
        try {
            const result = await axios.get(`/np/counterparties/${id}`);
            commit('changeNpCounterparty', result.data.models);
            return {
                status: true,
                data: result.data.models
            };
        } catch (e) {
            console.log(e);
            return {
                status: false,
                data: e.response?.data
            };
        }
    },

    updateNpCounterparty: async (ctx, { id, data }) => {
        try {
            const result = await axios.put(`/np/counterparties/${id}`, data);
            return {
                status: true,
                data: result.data
            };
        } catch (e) {
            return {
                status: false,
                data: e.response?.data
            };
        }
    },

    syncNpCounterparties: async (ctx, payload = {}) => {
        try {
            const result = await axios.post('/np/counterparties/sync', payload);
            return {
                status: true,
                data: result.data
            };
        } catch (e) {
            return {
                status: false,
                data: e.response?.data
            };
        }
    },

    syncNpCounterparty: async (ctx, id) => {
        try {
            const result = await axios.post(`/np/counterparties/${id}/sync`);
            return {
                status: true,
                data: result.data
            };
        } catch (e) {
            return {
                status: false,
                data: e.response?.data
            };
        }
    },

    getNpCounterpartiesForSelect: async () => {
        try {
            const result = await axios.get('/np/counterparties/for_select');
            return {
                status: true,
                data: result.data.models
            };
        } catch (e) {
            console.log(e);
            return {
                status: false,
                data: e.response?.data
            };
        }
    },

    createNpCounterparty: async (ctx, payload) => {
        try {
            const result = await axios.post('/np/counterparties', payload);
            return {
                status: true,
                data: result.data
            };
        } catch (e) {
            return {
                status: false,
                data: e.response?.data
            };
        }
    },

    removeNpCounterparty: async (ctx, id) => {
        try {
            const result = await axios.delete(`/np/counterparties/${id}`);
            return {
                status: true,
                data: result.data
            };
        } catch (e) {
            return {
                status: false,
                data: e.response?.data
            };
        }
    },
};

const mutations = {
    changeNpStatusMappings(state, data) {
        state.npStatusMappings = data;
    },
    changeNpStatusMapping(state, data) {
        state.npStatusMapping = data;
    },
    changeNpCodes(state, data) {
        state.npCodes = data;
    },
    changeCrmStatuses(state, data) {
        state.crmStatuses = data;
    },
    changeIgnoredStatuses(state, data) {
        state.ignoredStatuses = data;
    },
    changeNpCounterparties(state, data) {
        state.npCounterparties = data;
    },
    changeNpCounterparty(state, data) {
        state.npCounterparty = data;
    },
};

export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations,
};

